/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktResponseAppointmentAllOfMembersReservations
 */
export interface GetAktResponseAppointmentAllOfMembersReservations {
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseAppointmentAllOfMembersReservations
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseAppointmentAllOfMembersReservations
     */
    description: string;
}

export function GetAktResponseAppointmentAllOfMembersReservationsFromJSON(json: any): GetAktResponseAppointmentAllOfMembersReservations {
    return GetAktResponseAppointmentAllOfMembersReservationsFromJSONTyped(json, false);
}

export function GetAktResponseAppointmentAllOfMembersReservationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseAppointmentAllOfMembersReservations {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'],
    };
}

export function GetAktResponseAppointmentAllOfMembersReservationsToJSON(value?: GetAktResponseAppointmentAllOfMembersReservations | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
    };
}


